export const FORGOT_PASSWORD_CONFIRM = 'APP/FORGOT_PASSWORD_CONFIRM'
export const FORGOT_PASSWORD_CONFIRM_SUCCESS =
  'APP/FORGOT_PASSWORD_CONFIRM_SUCCESS'
export const FORGOT_PASSWORD_CONFIRM_ERROR =
  'APP/FORGOT_PASSWORD_CONFIRM_ERROR'
export const FORGOT_PASSWORD_CONFIRM_CLEAN_UP =
  'APP/FORGOT_PASSWORD_CONFIRM/CLEAN_UP'
